import TcCoverLoading from 'components/UI/TcLoading/TcCoverLoading';
import { IBackendGetGeneric } from 'global/Models/globalModels';
import { userAccessibleLKiosk } from 'global/Models/lockerModel';
import { lockerInfo, packageCreate } from 'global/Models/omOrderModel';
import OmParcelOrderModel from 'global/Models/omParcelOrderModel';
import { FC } from 'react';
import UserAccessibleKiosksTable from './compoonents/UserAccessibleKiosksTable';

interface Props {
  visible?: number;
  loading: boolean;
  errorMsg?: string;
  packages: packageCreate[] | undefined;
  index: number;
  userAccessibleKiosksList?: IBackendGetGeneric<userAccessibleLKiosk>;
  setLockerAddress?: (_locker: lockerInfo) => void;
}
const OrderSelectLockerListTab: FC<Props> = ({ visible, packages, loading, errorMsg, setLockerAddress, userAccessibleKiosksList, index }) => {
  return (
    <>
      <UserAccessibleKiosksTable
        userAccessibleKiosksList={userAccessibleKiosksList}
        loading={loading}
        setLockerAddress={setLockerAddress}
        cityId={visible}
        packages={packages}
        index={index}
      />
      {errorMsg && (
        <div className='flex flex-col items-center justify-center px-2 py-4 my-3 mt-2 text-center border border-dashed rounded-lg border-t-border-color-base'>
          <p>{errorMsg}</p>
          {errorMsg === OmParcelOrderModel.errorMessage ? (
            <p>{OmParcelOrderModel.lockerWasFulled}</p>
          ) : (
            <p>توجه داشته باشید، حداکثر ابعاد مجاز مرسوله ۳۱x۳۶x۳۸ سانتی متر و حداکثر وزن مجاز نیز ۲۰ کیلوگرم می باشد.</p>
          )}
        </div>
      )}
      {loading && <TcCoverLoading />}
    </>
  );
};

export default OrderSelectLockerListTab;
